import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CalendarModule } from 'primeng/calendar';
import { combineLatest } from 'rxjs';
import { PanelModule } from '../../../modules/panel.module';
import { BusinessListComponent } from '../../business/business-list/business-list.component';
import { BusinessService } from '../../../services/business.service';
import { OrderService } from '../../../services/order.service';

@Component({
  selector: 'brt-order-report',
  standalone: true,
  imports: [PanelModule, BusinessListComponent, CalendarModule],
  templateUrl: './order-report.component.html',
  styleUrl: './order-report.component.css'
})
export class OrderReportComponent {
  basePath = this.route.snapshot.data['basePath'] || '/';
  constructor(private route: ActivatedRoute, public router: Router, private businessService: BusinessService, private orderService: OrderService) {
    combineLatest([route.params, route.queryParams,]).subscribe(async ([params, queryParams]) => {
      const BusinessId = params['bid'];
      if (!BusinessId) return;
      this.business = await this.businessService.get(BusinessId);
      const FromDate = new Date();
      FromDate.setHours(5, 0, 0, 0);
      const ToDate = new Date();
      ToDate.setDate(ToDate.getDate() + 1);
      ToDate.setHours(5, 0, 0, 0);
      this.criteria = { ...queryParams, BusinessId, FromDate, ToDate };
      await this.load();
    });
  }

  loading: boolean;
  business: any;
  criteria: any;
  report: any;

  async load() {
    if (!this.criteria?.BusinessId) return;
    this.loading = true;
    this.report = await this.orderService.getReport(this.criteria);
    this.loading = false;
  }

  x(event: any) { console.log(event); }
}
